exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#clinic-show-doctor-comissions .modal-dialog{max-width:1340px}#clinic-show-doctor-comissions .clinic-show-doctor-comissions__header{color:#fff;background-color:var(--theme-color)}#clinic-show-doctor-comissions .clinic-show-doctor-comissions__header strong{display:inline-block;padding:8px}", ""]);

// exports
